import React from 'react';
import { Redirect, Route } from 'react-router-dom';

const normalizeDecision = decision => {
  if (decision === false) {
    return {
      allowed: false,
      redirectTo: '/access-denied',
      code: 'ACCESS_DENIED',
    };
  }

  if (decision === true || decision == null) {
    return {
      allowed: true,
    };
  }

  return decision;
};

const ProtectedRoute = ({
  component: Component,
  user,
  updateGlobalState,
  canAccess,
  remountOnParamChange = false,
  ...routeProps
}) => (
  <Route
    {...routeProps}
    render={routerProps => {
      const decision = normalizeDecision(
        canAccess
          ? canAccess({
              user,
              ...routerProps,
            })
          : true
      );

      if (!decision.allowed) {
        return (
          <Redirect
            to={{
              pathname: decision.redirectTo || '/access-denied',
              state: {
                from: routerProps.location.pathname,
                accessCode: decision.code,
              },
            }}
          />
        );
      }

      return (
        <Component
          key={remountOnParamChange ? routerProps.match.params.id : undefined}
          {...routerProps}
          user={user}
          updateGlobalState={updateGlobalState}
        />
      );
    }}
  />
);

export default ProtectedRoute;
